module.exports = __webpack_public_path__ + "static/media/mf.d3fbe0d9.svg";